/* RESPONSIBLE TEAM: team-standalone */
import { inject as service } from '@ember/service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import type RouterService from '@ember/routing/router-service';
import type GreatGuidanceService from 'embercom/services/great-guidance-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class StandaloneRoute extends IntercomRoute {
  @service declare appService: any;
  @service declare router: RouterService;
  @service declare store: any;
  @service declare greatGuidanceService: GreatGuidanceService;
  @service declare finStandaloneService: FinStandaloneService;

  get app(): any {
    return this.appService.app;
  }

  async beforeModel(transition: any) {
    await this.finStandaloneService.initialize();

    if (
      transition.to.name.startsWith('apps.app.standalone.setup') ||
      transition.to.name === 'apps.app.standalone.index'
    ) {
      this.router.transitionTo('apps.app.standalone.deploy.overview');
    }

    let appsController: any = this.controllerFor('apps/app');
    appsController.set('showPrimaryNav', false);
  }

  redirect(): any {
    if (!this.app.canUseStandalone) {
      return this.router.transitionTo('apps.app', this.app.id);
    }
  }
}
